import { SharedFunctionality } from '../api/lending/lapiHooks';

const isDevelopmentBuild = import.meta.env.MODE === 'development';

export function registerStateKey(stateKey: string) {
  if (isDevelopmentBuild) {
    console.log('[DEV] Registering statekey in FullStory', stateKey);
    return;
  }

  window.FS?.identify(stateKey, { stateKey_str: stateKey });
}

export function registerSharedFunctionalities(
  stateKey: string,
  sharedFunctionalities: Partial<Record<SharedFunctionality, boolean>>,
) {
  if (isDevelopmentBuild) {
    console.log(
      '[DEV] Registering shared functionalities in FullStory',
      sharedFunctionalities,
    );
    return;
  }

  window.FS?.identify(
    stateKey,
    Object.fromEntries(
      Object.entries(sharedFunctionalities).map(
        ([sharedFunctionality, enabled]) => [
          `${sharedFunctionality}_bool`,
          enabled,
        ],
      ),
    ),
  );
}
